import request from '../request';

function toQuery(params) {
	return Object.keys(params || {})
		.filter(k => params[k] !== undefined && params[k] !== null && params[k] !== '')
		.map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
		.join('&');
}

// ---- shared with web2 ----

export function getGlobalSetting() {
	return request({ url: 'api/global/lookup', method: 'get', noAuth: true });
}

export function getMemberInfo() {
	return request({ url: 'api/member/get-member-info', method: 'get' });
}

export function setLanguage(postData) {
	return request({ url: 'api/member/setLanguage', method: 'post', data: postData });
}

// wallet_type point18 (币释放钱包) -> external address; address_type trc20 / bep20
export function withdraw(postData) {
	return request({ url: 'api/wallet/withdraw', method: 'post', data: postData });
}

// withdraw_type COIN; optional wallet_type (e.g. point18) filters to that wallet
export function getWithdrawRecord(params) {
	return request({ url: 'api/wallet/withdraw-record?' + toQuery(params), method: 'get' });
}

// wallet: point17 (币质押钱包) / point18 (币释放钱包)
export function getUserWalletRecord(params) {
	return request({ url: 'api/record/wallet-record?' + toQuery(params), method: 'get' });
}

// ---- coin ----

// NGT1 -> coin conversions (质押明细); filters: from_wallet, to_wallet, start_date, end_date
export function convertCoinRecord(params) {
	return request({ url: 'api/coin/convertCoinRecord?' + toQuery(params), method: 'get' });
}

// today_release, total_release, record (paginated point18 credits, ?page=)
export function coinReleaseSummary(params) {
	return request({ url: 'api/coin/coinReleaseSummary?' + toQuery(params), method: 'get' });
}
